export default __webpack_public_path__ + "static/media/p5.6acc1e31.png";